// extracted by mini-css-extract-plugin
module.exports = {"confirm":"_3R0ihN","priceCurrency":"_57e7At","priceLabel":"_3W8yvK","price":"_2DJurv mz-default-dark-font","button":"_3DYcB1","greenCTA":"IeLT9a mz-cta-green"};